import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePersonRequest } from '../../store/modules/person/actions';

import Modal from 'react-modal';
import { toast } from 'react-toastify';

import api from '../../services/api';
import jsPdfGenerator from '../../services/generatePDF';


import * as S from './styled';

import Input from '../../components/Input';
import Button from '../../components/Button';
import Small from '../../components/Small';
import Title from '../../components/Title';
import Layout from '../../pages/_layouts/default';



const Search = props => {

  const dispatch = useDispatch();
  const loading = useSelector(state => state.auth.loading);

  const [cpf, setCpf] = useState('');
  const [borderCpf, setBorderCpf] = useState('#FDCB00');



  const [name, setName] = useState("");
  const [modalCpf, setModalCpf] = useState("");

  const [birthday, setBirthday] = useState("");
  const [family_count, setFamily_count] = useState("");
  const [ocupation, setOcupation] = useState("");
  const [status, setStatus] = useState("");
  const [nis, setNis] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [createdby, setCreatedBy] = useState("");


  const [borderName, setBorderName] = useState("");
  const [borderBirthday, setBorderBirthday] = useState("");
  const [borderFamily_count, setBorderFamily_count] = useState("");
  const [borderOcupation, setBorderOcupation] = useState("");
  const [borderStatus, setBorderStatus] = useState("");
  const [borderNis, setBorderNis] = useState("");
  const [borderContact, setBorderContact] = useState("");
  const [borderAddress, setBorderAddress] = useState("");
  const [borderNeighborhood, setBorderNeighborhood] = useState("");


  
  const [disabled, setDisabled] = useState(true);



  function handleSubmit(e) {
    e.preventDefault();
    
    if(!cpf) {
      toast.error('Campo vazio!');
      return;
    }

    api.get(`persons/${cpf}`)
      .then(res => {

        const {
          name, 
          birthday, 
          status, 
          ocupation, 
          family_count, 
          cpf, 
          nis, 
          contact, 
          address, 
          neighborhood,
          createdby
        } = res.data.person;

        setName(name);
        setModalCpf(cpf);
        setBirthday(birthday);
        setFamily_count(family_count);
        setOcupation(ocupation);
        setStatus(status);
        setNis(nis);
        setContact(contact);
        setAddress(address);
        setNeighborhood(neighborhood);
        setCreatedBy(createdby);
        
      })
      .then(openModal());
  }


  const customStyles = {
    overlay: {
      backgroundColor       : 'rgba(0,0,0, .75)'
    },
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
      transform             : 'translate(-50%, -50%)'
    }
  };

  Modal.setAppElement('#root')

  const [modalIsOpen,setIsOpen] = React.useState(false);
  function openModal() {
    setIsOpen(true);
  }

  function closeModal(){
    setIsOpen(false);
    setDisabled(true);
    setBorderName("");
    setBorderBirthday("");
    setBorderFamily_count("");
    setBorderOcupation("");
    setBorderStatus("");
    setBorderNis("");
    setBorderContact("");
    setBorderAddress("");
    setBorderNeighborhood("");
  }


  function editFields (e) {
    e.preventDefault();
    setDisabled(false);
    setBorderName("#FDCB00");
    setBorderBirthday("#FDCB00");
    setBorderFamily_count("#FDCB00");
    setBorderOcupation("#FDCB00");
    setBorderStatus("#FDCB00");
    setBorderNis("#FDCB00");
    setBorderContact("#FDCB00");
    setBorderAddress("#FDCB00");
    setBorderNeighborhood("#FDCB00");
  }
  

  function handlePDF (e) {
    e.preventDefault();
    jsPdfGenerator(name, cpf, nis, family_count, ocupation, address, birthday, contact, neighborhood, status, createdby);
  }



  function validationInput(e, inputType) {

    if (inputType === 'name') {

      const inputLength = e.length;

      if (inputLength <= 5) {
        setBorderName('#CE1717');
      } else {
        setBorderName('#1FA528');
      }
    }

    if (inputType === 'cpf') {

      const inputLength = e.replace(/_/g, '').length;

      if (inputLength < 14) {
        setBorderCpf('#CE1717');
      } else {
        setBorderCpf('#1FA528');
      }
    }

    if(inputType === 'birthday') {
      
      const inputLength = e.replace(/_/g, '').length;
      
      if (inputLength < 10) {
        setBorderBirthday('#CE1717');
      } else {
        setBorderBirthday('#1FA528');
      }
    }

    if(inputType === 'ocupation') {

     if (e.length > 0) {
      setBorderOcupation('#1FA528');
     } else {
      setBorderOcupation('#CE1717');
     }
    }

    if(inputType === 'status') {

     if (e.length > 0) {
      setBorderStatus('#1FA528');
     } else {
      setBorderStatus('#CE1717');
     }
    }

    if(inputType === 'nis') {

      if (e.length >= 6) {
        setBorderNis('#1FA528');
      } else {
        setBorderNis('#CE1717');
      }
    }
    
    if(inputType === 'address') {

      if (e.length >= 6) {
        setBorderAddress('#1FA528');
      } else {
        setBorderAddress('#CE1717');
      }
    }
    
    if(inputType === 'neighborhood') {

      if (e.length >= 6) {
        setBorderNeighborhood('#1FA528');
      } else {
        setBorderNeighborhood('#CE1717');
      }
    }

    if(inputType === 'contact') {
      
      const inputLength = e.replace(/_/g, '').length;
      
      if (inputLength < 15) {
        setBorderContact('#CE1717');
      } else {
        setBorderContact('#1FA528');
      }
    }
    
    if(inputType === 'family_count') {
      
      const inputLength = e.length;
      
      if (inputLength === 0) {
        setBorderFamily_count('#CE1717');
      } else {
        setBorderFamily_count('#1FA528');
      }
    }
    
  }


  function handleUpdateSubmit(e) {
    e.preventDefault();
    dispatch(updatePersonRequest(
      name, birthday, status, ocupation, family_count, cpf, nis, contact, address, neighborhood, createdby
    ));
  }

  function handleDelivery(e) {
    e.preventDefault();
  
      api.put(`/deliveries/${cpf}/update`, {
        op: true,
      }).then(function (response) {
        toast.success('Benefício entregue!');
      }).catch(function (err) {
        toast.error(err.response.data.error)
      })
      
      // toast.success('Donativo entregue')
      
  
  }

  return(
    <Layout>
      <>
      <S.FormWrapper>
        <Title text="buscar pessoa" />
        <S.Form onSubmit={handleSubmit}>
          <Input 
            type="text" 
            placeholder="000.000.000-00"
            mask="999.999.999-99" 
            label="Buscar pessoa"
            value={ cpf }
            method={ e => {
              setCpf(e.target.value);
              validationInput(e.target.value, 'cpf'); 
            }}
            border={ borderCpf }
          />
        <S.ControlsWrapper>
          <Small to="/dashboard">Voltar</Small>
          <Button type="submit" text={ loading ? 'Carregando...' : 'Buscar' } background="#0B4683"/>
        </S.ControlsWrapper>
        </S.Form>
      </S.FormWrapper>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
          

          <S.ModalBody>
            <S.ModalButton onClick={closeModal}>
              <S.CloseIcon />
            </S.ModalButton>



            <S.Form >
              <Title text="dados" />
              <div>
                <Input 
                  type="text" 
                  placeholder="Nome completo" 
                  label="Nome"
                  value={ name }
                  method={ 
                   e => {
                      setName(e.target.value);
                      validationInput(e.target.value, 'name')
                    }
                  }
                  width="60%"
                  border={ borderName }
                  disabled={ disabled }
                />
                <Input 
                  type="text" 
                  placeholder="21/02/1990"
                  mask="99/99/9999" 
                  label="Data de nascimento" 
                  value={ birthday }
                  width="40%"
                  method={ 
                    e => {
                       setBirthday(e.target.value);
                       validationInput(e.target.value, 'birthday')
                     }
                  }
                  border={ borderBirthday }
                  disabled={ disabled }
                />
                
              </div>
              <div>
                <Input 
                  type="text" 
                  placeholder="000.000.000-00"
                  mask="999.999.999-99" 
                  label="CPF"
                  value={ modalCpf }
                  width="40%"
                  disabled={ disabled }
                />
                <Input 
                  type="text" 
                  placeholder="00"
                  max="2"
                  pattern="/^[0-9\b]+$/"
                  label="Familiares" 
                  value={ family_count }
                  width="20%"
                  method={ 
                    e => {
                      const regex = /^[0-9\b]+$/;
                      const value = e.target.value;
                      if (value === '' || regex.test(value)) { 
                        setFamily_count(e.target.value);
                        setBorderFamily_count('#1FA528');
                      } else {
                        setBorderFamily_count('#CE1717');
                      }
                      validationInput(e.target.value, 'family_count')
                    }}
                  border={ borderFamily_count }
                  disabled={ disabled }
                />
                <Input 
                  type="text" 
                  placeholder="Profissão" 
                  label="Ocupação" 
                  width="50%"
                  value={ ocupation }
                  method={ 
                    e => {
                       setOcupation(e.target.value);
                       validationInput(e.target.value, 'ocupation')
                     }
                  }
                  border={ borderOcupation }
                  disabled={ disabled }
                />
              </div>
              <div>
                <Input 
                  type="text" 
                  placeholder="Solteiro, casado..." 
                  label="Estado Civil" 
                  value={ status }
                  method={ 
                    e => {
                       setStatus(e.target.value);
                       validationInput(e.target.value, 'status')
                     }
                  }
                  border={ borderStatus }
                  disabled={ disabled }
                />
                <Input 
                  type="text" 
                  placeholder="Nº do Nis" 
                  label="NIS" 
                  value={ nis }
                  method={ 
                    e => {
                      const regex = /^[0-9\b]+$/;
                      const value = e.target.value;
                      if (value === '' || regex.test(value)) { 
                        setNis(e.target.value);
                        setBorderNis('#1FA528');
                      } else {
                        setBorderNis('#CE1717');
                      }
                      validationInput(e.target.value, 'nis')
                     }
                  }
                  border={ borderNis }
                  disabled={ disabled }
                />
                <Input 
                  type="text" 
                  placeholder="(81) 90000-0000"
                  mask="(99) 99999-9999" 
                  label="Telefone" 
                  value={ contact }
                  method={ 
                    e => {
                       setContact(e.target.value);
                       validationInput(e.target.value, 'contact')
                     }
                  }
                  border={ borderContact }
                  disabled={ disabled }
                />
              </div>
              <div>
                <Input 
                  type="text" 
                  placeholder="Rua, Avenida, Sítio e Nº" 
                  label="Endereço" 
                  width="60%"
                  value={ address }
                  method={ 
                    e => {
                       setAddress(e.target.value);
                       validationInput(e.target.value, 'address')
                     }
                  }
                  border={ borderAddress }
                  disabled={ disabled }
                />
                <Input 
                  type="text" 
                  placeholder="Bairro" 
                  label="Bairro" 
                  width="40%"
                  value={ neighborhood }
                  method={ 
                    e => {
                       setNeighborhood(e.target.value);
                       validationInput(e.target.value, 'neighborhood')
                     }
                  }
                  border={ borderNeighborhood }
                  disabled={ disabled }
                />
                <Input 
                  type="text" 
                  placeholder="Bairro" 
                  label="Cadastrante" 
                  value={ createdby }
                  width="40%"
                  disabled={ disabled }
                />
              </div>
              <S.ControlsWrapper modal>
                <Button method={editFields} text={ loading ? 'Carregando...' : 'Editar' } background="#CE1717" />
                <Button method={handleDelivery} type="submit" text={ loading ? 'Carregando...' : 'Entregar Donativo' } background="#1FA528" />
                <Button method={handlePDF} text={ loading ? 'Carregando...' : 'Gerar PDF' } background="#FDCB00" />
                <Button method={handleUpdateSubmit} disabled={ disabled ? true : false } text={ loading ? 'Carregando...' : 'Atualizar' } background="#0B4683" />
              </S.ControlsWrapper>
            </S.Form>

          </S.ModalBody>
          
        </Modal>
      </>
    </Layout>
  );
}

export default Search;